import React, { useState } from 'react';
import { uploadFileToFirebase } from '../utils/firebaseUploadUtils';
import UploadIcon from './icons/UploadIcon';
import FileIcon from './icons/FileIcon';
import {
    AttachmentContainer,
    FileInput,
    UploadButton,
    AttachmentList,
    AttachmentItem,
    ImagePreview,
    FilePreview,
    DeleteButton,
    AttachmentTitle
} from '../styles/AttachmentSection.styles';

const AttachmentSection = ({ attachments = [], onAddAttachment, onDeleteAttachment }) => {
    const [uploading, setUploading] = useState(false);

    const handleFileSelect = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setUploading(true);
        try {
            const attachment = await uploadFileToFirebase(file, 'attachments');

            onAddAttachment(attachment);
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setUploading(false);
        }
    };

    const isImage = (type) => type.startsWith('image/');

    const renderAttachment = (attachment) => (
        <AttachmentItem key={attachment.id}>
            {isImage(attachment.type) ? (
                <ImagePreview
                    url={attachment.url}
                    onClick={() => window.open(attachment.url, '_blank')}
                />
            ) : (
                <FilePreview onClick={() => window.open(attachment.url, '_blank')}>
                    <FileIcon />
                    {attachment.name}
                </FilePreview>
            )}
            <AttachmentTitle>
                {attachment.name}
                <DeleteButton onClick={() => onDeleteAttachment(attachment.id)}>
                    Delete
                </DeleteButton>
            </AttachmentTitle>
        </AttachmentItem>
    );

    return (
        <AttachmentContainer>
            <FileInput
                type="file"
                id="file-input"
                onChange={handleFileSelect}
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            />
            {/* <UploadButton
                onClick={() => document.getElementById('file-input').click()}
                disabled={uploading}
            >
                <UploadIcon />
                {uploading ? 'Uploading...' : 'Add attachment'}
            </UploadButton> */}

            <AttachmentList>
                {attachments.map(renderAttachment)}
            </AttachmentList>
        </AttachmentContainer>
    );
};

export default AttachmentSection;